import { type SyncPositionStatusResponse } from "../api";
import { SyncStatus } from "./sync_status";

export interface PositionSyncStatus extends SyncPositionStatusResponse {}

export class PositionSyncStatus extends SyncStatus<PositionSyncStatus> {
  constructor(init?: Partial<SyncPositionStatusResponse>) {
    super();
    Object.assign(this, init);
  }
}
